import { StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFFFFF",
    //padding: "20px 50px",
    fontFamily: "Open Sans",
  },

  textContent: {
    fontSize: 10,
    marginTop: 5,
    marginBottom: 5,
  },
});

const jsonView = {
  type: "page",
  items: [
    {
      type: "view",
      styles: {
        //paddingLeft: 25,
        paddingTop: 8,
      },
      items: [
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginTop: 15,
            justifyContent: "center",
          },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 18,
                fontFamily: "Roboto-Bold",
              },
              content: "APPENDIX I",
            },
               {
              type: "text",
              styles: {
                fontSize: 18,
                fontFamily: "Roboto-Bold",
              },
              content: " — ",
            },
            {
              type: "text",
              styles: {
                fontSize: 16,
                fontFamily: "Roboto-Bold",
              },
              content: "ITINERARY - PASSENGERS - AMENDMENTS",
            },
          ],
        },

        {
          type: "text",
          styles: {
            fontSize: 11,
            marginTop: 10,
            marginBottom: 5,
            fontFamily: "Roboto-Bold",
            textAlign: "center",
          },
          content: "ITINERARY",
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
          },
          items: [
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 11,
              },
              content: "CRUISING AREA : ",
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 11,
              },
              content: " __itineraryCruisingArea__",
            },
          ],
        },
      ],
    },

    {
      type: "view",
      styles: {
        //margin: 10,
        marginTop: 20,
        padding: 10,
        border: "1pt solid #000000",
        height: "70vh",
      },
      items: [
        {
          type: "view",
          styles: {
            flexDirection: "row",
          },
          items: [
            {
              type: "view",
              styles: {
                width: "40%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    textAlign: "center",
                    fontSize: 11,
                  },
                  content: "PORT",
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    textAlign: "center",
                    fontSize: 11,
                    width: "70px",
                  },
                  content: "Date - Time of Arrival",
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    textAlign: "center",
                    fontSize: 11,
                    width: "70px",
                  },
                  content: "Date - Time of Departure",
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
          },
          items: [
            {
              type: "view",
              styles: {
                width: "40%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: 9,
                    paddingTop: 15,
                    textTransform: "uppercase",
                  },
                  content: "Port of embarkation",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    textAlign: "left",
                    fontSize: 11,
                  },
                  content: "__itineraryEmbarkationPort__",
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    textAlign: "left",
                  },
                  content: "",
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    marginBottom: 0,
                  },
                  content: " ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    textAlign: "left",
                    marginBottom: 15,
                    fontSize: 9,
                    paddingTop: 15,
                  },
                  content:
                    "__cruiseStartDateItinerary__ __cruiseStartTimeItinerary__",
                },
              ],
            },
          ],
        },

        {
          type: "view",
          repeated: true,
          findRepeated: "itineraryPorts_name",
          styles: {
            flexDirection: "row",
          },
          items: [
            {
              type: "view",
              styles: {
                width: "40%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    textAlign: "left",
                    fontSize: 11,
                  },
                  content: "__itineraryPorts_name__",
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    textAlign: "left",
                    fontSize: 9,
                  },
                  content:
                    "__itineraryPorts_arrival__ __itineraryPorts_arrivalTime__",
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    textAlign: "left",
                    fontSize: 9,
                  },
                  content:
                    "__itineraryPorts_departure__ __itineraryPorts_departureTime__",
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
          },
          items: [
            {
              type: "view",
              styles: {
                width: "40%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: 9,
                    paddingTop: 15,
                    textTransform: "uppercase",
                  },
                  content: "Port of disembarkation",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    textAlign: "left",
                    fontSize: 11,
                  },
                  content: "__itineraryDismbarkationPort__",
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    marginBottom: 0,
                  },
                  content: " ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    textAlign: "left",
                    fontSize: 9,
                    paddingTop: 20,
                  },
                  content:
                    "__cruiseEndDateItinerary__ __cruiseEndTimeItinerary__",
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    textAlign: "left",
                  },
                  content: "",
                },
              ],
            },
          ],
        },
        {
          type: "view",

          styles: {
            position: "absolute",
            bottom: -110,
            left: 0,
            display: "flex",
            flexDirection: "row",
          },

          items: [
            {
              type: "view",

              styles: { width: "30%" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                  },

                  content: "PLEASE INITIAL",
                },
              ],
            },
            {
              type: "view",

              styles: { width: "100%", flexDirection: "row" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                  },

                  content: "CAPTAIN ______________",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                    marginLeft: 50,
                  },

                  content: "CLIENT _______________",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default jsonView;
